import { render, staticRenderFns } from "./ReviewPanel.vue?vue&type=template&id=5ae32ca8&scoped=true&"
import script from "./ReviewPanel.vue?vue&type=script&lang=js&"
export * from "./ReviewPanel.vue?vue&type=script&lang=js&"
import style0 from "./ReviewPanel.vue?vue&type=style&index=0&id=5ae32ca8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae32ca8",
  null
  
)

export default component.exports